























































































































































































































































































































































































































































































































































































import { Invoiceable } from '../../domain/Invoiceable';
import { getPaymentMeansMessage } from '../../domain/Invoiceable';
import { mapGetters } from "vuex"


export default {
    name: 'PageFacturae',
    props: {

        page: {
            type: Object,
            required: true,
        },
        num_page: {
            type: Number,
            required: true,
        },
        total_pages: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            invoiceable: this.page.invoiceable,
            configuration: this.page.configuration,
            rectified_inv: this.page.rectified_inv,
            productConfiguration: this.page.productConfiguration,
            total_lines: 0
        }
    },
    mounted() {
        this.invoiceable.compute()
        // Total de líneas imprimibles (sin contar bloques extra de totales/footers)
        this.total_lines = this.invoiceable.get_lines_with_additional_descriptions().length
    },
    watch: {
        // Recalcular el total de líneas cuando cambien
        computed_lines(newLines: any[]) {
            this.total_lines = newLines.length
        }
    },
    computed:{
        proformaHeader(): any | null {
            if (!((this.invoiceable.type === 'invoice' && this.invoiceable.related_invoiceables_type === 'proforma'))) {
                return null
            }
            const linea = this.computed_lines.find((item: any) =>
                item.additional_information &&
                item.additional_information.sender_info &&
                (item.additional_information.sender_info.budget_number ||
                 item.additional_information.sender_info.budget_date)
            )
            return linea
                ? {
                    budget_number: linea.additional_information.sender_info.budget_number,
                    budget_date: linea.additional_information.sender_info.budget_date,
                    record_reference: linea.additional_information.record_reference,
                    record_reference_date: linea.additional_information.record_reference_date
                }
                : null
        },

        presupuestoHeader(): any | null {
            if (!((this.invoiceable.type === 'invoice' && this.invoiceable.related_invoiceables_type === 'budget'))) {
                return null
            }
            const linea = this.computed_lines.find((item: any) =>
                item.additional_information &&
                item.additional_information.sender_info &&
                (item.additional_information.sender_info.budget_number ||
                 item.additional_information.sender_info.budget_date)
            )
            return linea
                ? {
                    budget_number: linea.additional_information.sender_info.budget_number,
                    budget_date: linea.additional_information.sender_info.budget_date,
                    record_reference: linea.additional_information.record_reference,
                    record_reference_date: linea.additional_information.record_reference_date
                }
                : null
        },

        computed_lines(): any[] {
            return this.invoiceable.get_lines_with_additional_descriptions()
        },

        tax_type_to_show(): string {
            return this.invoiceable.tax_type === 'igic' ? 'IGIC' : 'IVA'
        },

        im_suplido_only_invoice(): boolean {
            const isReimbursableExpense =
                (Array.isArray(this.invoiceable.reimbursable_amounts) &&
                 this.invoiceable.reimbursable_amounts.length > 0) ||
                 Boolean(this.invoiceable.reimbursable_expense_concept)
            const hasLines = this.computed_lines.length > 0
            return isReimbursableExpense && !hasLines
        },
        additionalInfoChunks(): string[] {
            return this.page.additionalInfoChunks || []
        },
        additionalInfoNumPages(): number {
            return this.additionalInfoChunks.length
        },
        currentAdditionalInfoChunk(): string | null {
            if (this.additionalInfoNumPages === 0) return null
            const firstAdditionalInfoLine = this.total_lines + 1
            const matchingChunks: string[] = []
            for (let i = 0; i < this.additionalInfoNumPages; i++) {
                const chunkLineIndex = firstAdditionalInfoLine + i
                if (this.page.lastPrintedLine >= chunkLineIndex && this.page.firstPrintedLine < chunkLineIndex) {
                    matchingChunks.push(this.additionalInfoChunks[i])
                }
            }
            return matchingChunks.length > 0 ? matchingChunks.join('\n') : null
        },
        pageIncludesAdditionalLine(): boolean {
            return this.currentAdditionalInfoChunk !== null
        },
        pageIncludesFooter(): boolean {
            const footerLineIndex = this.invoiceable.additional_info
                ? this.total_lines + 1 + this.additionalInfoNumPages
                : this.total_lines + 1
            return this.page.lastPrintedLine >= footerLineIndex && this.page.firstPrintedLine < footerLineIndex
        },
        pageIsTotals(): boolean {
            return this.page.lastPrintedLine >= this.total_lines && this.page.firstPrintedLine < this.total_lines
        },
        showAdditionalInfo(): boolean {
            if (!this.invoiceable.additional_info) return false
            return this.pageIncludesAdditionalLine
        },
        showPaymentMessage(): boolean {
            return this.pageIsTotals
        },
        showFooter(): boolean {
            if (!this.configuration || !this.configuration.footer) return false
            return this.pageIncludesFooter
        },
        showFooterSmall(): boolean {
            if (!this.configuration || !this.configuration.footer_small) return false
            return this.pageIncludesFooter
        },
        additionalFieldsConfig() {
            return (this.productConfiguration && this.productConfiguration.fields) ? this.productConfiguration.fields : [];
        },
        // Computed property to translate dynamically the document name
        documentTypeLabel(): string {
            const typeMap = {
                'factura': this.$t('PageFacturae.invoice'),
                'presupuesto': this.$t('PageFacturae.budget'),
                'albarán': this.$t('PageFacturae.delivery_note'),
                'proforma': this.$t('PageFacturae.proforma'),
                'ticket': this.$t('PageFacturae.ticket'),
            }
            return typeMap[this.invoiceable.name] || this.invoiceable.name
        }
    },
    methods: {
        // Helper to obtain the suffix of details according to the document type
        getDetailsLabel() {
            const suffixMap = {
                'budget': ' ' + this.$t('PageFacturae.details_of_budget'),
                'delivery_note': ' ' + this.$t('PageFacturae.details_of_delivery_note'),
                'proforma': ' ' + this.$t('PageFacturae.details_of_proforma'),
                'ticket': ' ' + this.$t('PageFacturae.details_of_ticket'),
            }
            return suffixMap[this.invoiceable.type] || ' ' + this.$t('PageFacturae.details_of_invoice')
        },

        // Helper to obtain the translation of the document type
        getDocumentTypeLabel() {
            const typeMap = {
                'invoice': this.$t('PageFacturae.invoice'),
                'budget': this.$t('PageFacturae.budget'),
                'delivery_note': this.$t('PageFacturae.delivery_note'),
                'proforma': this.$t('PageFacturae.proforma'),
                'ticket': this.$t('PageFacturae.ticket'),
            }
            return typeMap[this.invoiceable.type] || this.invoiceable.type
        },

        formatCurrency(value) {
            if (value === null || value === undefined) return '0,00 €';

            const numValue = typeof value === 'string' ? parseFloat(value) : value;            
            const fixed = numValue.toFixed(2);
            const [integer, decimal] = fixed.split('.');
            
            // Add dots every 3 digits from the right for thousands
            const formattedInteger = integer.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            
            return `${formattedInteger},${decimal} €`;
        },
        payment_message(payment_means){
            return getPaymentMeansMessage(payment_means);
        },

        get_total_amount(invoice_line) {
            let gross = invoice_line.gross_amount;
            if (invoice_line.discounts.length > 0 && invoice_line.discounts[0].rate > 0)
                gross -= gross * invoice_line.discounts[0].rate / 100;
            let tax_amount = gross * invoice_line.taxes[0].rate;
            let recargo = 0;
            //console.log(invoice_line.taxes[0])
            if (invoice_line.taxes[0].recargo_amount) {
                recargo = invoice_line.taxes[0].recargo_amount;
            }
            let withheld_amount = 0;
            if (invoice_line.taxes_withheld.length) {
                withheld_amount = invoice_line.taxes_withheld[0].amount
            }
            return gross + tax_amount + recargo - withheld_amount;
        },
        formatInvoiceDate(date) {
          if (!date) return '';
          const [year, month, day] = date.split('-');
          return `${day}/${month}/${year}`;
        },
        formatField(field) {
            const fieldMap = {
                0.21: '21%',
                0.10: '10%',
                0.04: '4%',
                0.00: '0%',
                0.005: '4% RE 0.5%',
                0.014: '10% RE 1.4%',
                0.052: '21% RE 5.2%',
                na: '-',
                0.07: '7%',
                0.15: '15%',
                0.19: '19%',
            };

            return fieldMap[field] || field;
        },
        getAdditionalFieldValue(invoice_line, fieldKey) {
            if (!invoice_line.additional_fields || !Array.isArray(invoice_line.additional_fields)) {
                return '-';
            }
            const field = invoice_line.additional_fields.find(f => f.key === fieldKey);
            return field ? field.value : '-';
        }
    },
    

}
